import { useStressAssessmentSummary } from '../../hooks';
import { StressAssessmentSummaryPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof StressAssessmentSummaryPresentation>;
type Args = { data: ReturnType<typeof useStressAssessmentSummary>['state']['data'] };
type IConvertToPresentationProps = (args: Args) => PresentationProps;

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  // dataがundefinedの場合は全ての値を0にする
  // TODO: loading時の表示を追加する
  if (!data) {
    return {
      title: 'レポート',
      totalUserCount: 0,
      completedUserCount: 0,
      completedUserRate: 0,
      highStressUserCount: 0,
      highStressUserRate: 0,
      pendingUserCount: 0,
      pendingUserRate: 0,
      dataPoints: [
        {
          chartTitle: 'ストレスの原因と考えられる因子',
          data: [
            { label: '1. 心理的仕事の負担（量）', value: 0 },
            { label: '2. 心理的仕事\nの負担（質）', value: 0 },
            { label: '3. 自覚的な身体\n的負担度', value: 0 },
            { label: '4. 職場の対人関係\nでのストレス', value: 0 },
            { label: '5. 職場環境によるストレス', value: 0 },
            { label: '6. 仕事のコントロール度', value: 0 },
            { label: '7. 技能の活用度', value: 0 },
            { label: '8. 仕事の適性度', value: 0 },
            { label: '9. 働きがい', value: 0 },
          ],
        },
        {
          chartTitle: 'ストレスによって起こる心身の反応',
          data: [
            { label: '1. 活気', value: 0 },
            { label: '2. イライラ感', value: 0 },
            { label: '3. 疲労感', value: 0 },
            { label: '4. 不安感', value: 0 },
            { label: '5. 抑うつ感', value: 0 },
            { label: '6. 身体愁訴', value: 0 },
          ],
        },
        {
          chartTitle: 'ストレスに影響を与える他の因子',
          data: [
            { label: '1. 上司からのサポート', value: 0 },
            { label: '2. 同僚からの\nサポート', value: 0 },
            { label: '3. 家族友人からのサポート', value: 0 },
            { label: '4. 仕事や生活の\n満足度', value: 0 },
          ],
        },
      ],
    };
  }

  const summary = data.stress_assessment_summary;

  return {
    title: summary.stress_assessment?.title || 'レポート',
    totalUserCount: summary.total_count,
    completedUserCount: summary.completed_count,
    completedUserRate: Math.round(summary.completed_rate),
    highStressUserCount: summary.high_stress_count,
    highStressUserRate: Math.round(summary.high_stress_rate),
    pendingUserCount: summary.pending_count,
    pendingUserRate: Math.round(summary.pending_rate),
    dataPoints: [
      {
        chartTitle: 'ストレスの原因と考えられる因子',
        data: [
          { label: '1. 心理的仕事の負担（量）', value: summary.psychological_workload_quantity },
          { label: '2. 心理的仕事\nの負担（質）', value: summary.psychological_workload_quality },
          { label: '3. 自覚的な身体\n的負担度', value: summary.subjective_physical_burden_level },
          {
            label: '4. 職場の対人関係\nでのストレス',
            value: summary.interpersonal_stress_at_work,
          },
          { label: '5. 職場環境によるストレス', value: summary.environmental_stress_at_work },
          { label: '6. 仕事のコントロール度', value: summary.job_control_level },
          { label: '7. 技能の活用度', value: summary.skill_utilization_level },
          { label: '8. 仕事の適性度', value: summary.job_aptitude_level },
          { label: '9. 働きがい', value: summary.work_engagement_level },
        ],
      },
      {
        chartTitle: 'ストレスによって起こる心身の反応',
        data: [
          { label: '1. 活気', value: summary.vitality_level },
          { label: '2. イライラ感', value: summary.irritability_level },
          { label: '3. 疲労感', value: summary.fatigue_level },
          { label: '4. 不安感', value: summary.anxiety_level },
          { label: '5. 抑うつ感', value: summary.depression_level },
          { label: '6. 身体愁訴', value: summary.physical_complaints_level },
        ],
      },
      {
        chartTitle: 'ストレスに影響を与える他の因子',
        data: [
          { label: '1. 上司からのサポート', value: summary.supervisor_support_level },
          { label: '2. 同僚からの\nサポート', value: summary.coworker_support_level },
          { label: '3. 家族友人からのサポート', value: summary.family_friend_support_level },
          { label: '4. 仕事や生活の\n満足度', value: summary.job_satisfaction_level },
        ],
      },
    ],
  };
};
